// Generated by purs version 0.13.8
"use strict";
var Control_Bind = require("../Control.Bind/index.js");
var Control_Monad_Reader_Class = require("../Control.Monad.Reader.Class/index.js");
var Control_Monad_State_Class = require("../Control.Monad.State.Class/index.js");
var Data_Functor = require("../Data.Functor/index.js");
var Data_Lens_Getter = require("../Data.Lens.Getter/index.js");
var Data_Lens_Internal_Forget = require("../Data.Lens.Internal.Forget/index.js");
var Data_Maybe = require("../Data.Maybe/index.js");
var Data_Ord = require("../Data.Ord/index.js");
var Data_Symbol = require("../Data.Symbol/index.js");
var Data_Unit = require("../Data.Unit/index.js");
var Effect_Class = require("../Effect.Class/index.js");
var Effect_Ref = require("../Effect.Ref/index.js");
var Halogen_Component = require("../Halogen.Component/index.js");
var Halogen_HTML = require("../Halogen.HTML/index.js");
var Halogen_Query_EventSource = require("../Halogen.Query.EventSource/index.js");
var Halogen_Query_HalogenM = require("../Halogen.Query.HalogenM/index.js");
var Lunarbox_Component_Utils = require("../Lunarbox.Component.Utils/index.js");
var Lunarbox_Config = require("../Lunarbox.Config/index.js");
var Record = require("../Record/index.js");
var Initialize = (function () {
    function Initialize() {

    };
    Initialize.value = new Initialize();
    return Initialize;
})();
var HandleUserBus = (function () {
    function HandleUserBus(value0) {
        this.value0 = value0;
    };
    HandleUserBus.create = function (value0) {
        return new HandleUserBus(value0);
    };
    return HandleUserBus;
})();
var Receive = (function () {
    function Receive(value0) {
        this.value0 = value0;
    };
    Receive.create = function (value0) {
        return new Receive(value0);
    };
    return Receive;
})();
var Emit = (function () {
    function Emit(value0) {
        this.value0 = value0;
    };
    Emit.create = function (value0) {
        return new Emit(value0);
    };
    return Emit;
})();
var _inner = Data_Symbol.SProxy.value;
var component = function (dictMonadAff) {
    return function (dictMonadAsk) {
        return function (dictLacks) {
            return function (innerComponent) {
                var render = function (state) {
                    return Halogen_HTML.slot()(new Data_Symbol.IsSymbol(function () {
                        return "inner";
                    }))(Data_Ord.ordUnit)(_inner)(Data_Unit.unit)(innerComponent)(state)(function ($24) {
                        return Data_Maybe.Just.create(Emit.create($24));
                    });
                };
                var handleQuery = Halogen_Query_HalogenM.query()(new Data_Symbol.IsSymbol(function () {
                    return "inner";
                }))(Data_Ord.ordUnit)(_inner)(Data_Unit.unit);
                var handleAction = function (v) {
                    if (v instanceof Initialize) {
                        return Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)(Control_Monad_Reader_Class.asks(Halogen_Query_HalogenM.monadAskHalogenM(dictMonadAsk))(Data_Lens_Getter.view(Lunarbox_Config["_user"](Data_Lens_Internal_Forget.strongForget))))(function (v1) {
                            return Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)(Halogen_Query_HalogenM.subscribe(Data_Functor.map(Halogen_Query_EventSource.functorEventSource(((((dictMonadAff.MonadEffect0()).Monad0()).Bind1()).Apply0()).Functor0()))(HandleUserBus.create)(Lunarbox_Component_Utils.busEventSource(dictMonadAff)(v1.userBus))))(function () {
                                return Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)(Effect_Class.liftEffect(Halogen_Query_HalogenM.monadEffectHalogenM(dictMonadAff.MonadEffect0()))(Effect_Ref.read(v1.currentUser)))(function (mbProfile) {
                                    return Control_Monad_State_Class.modify_(Halogen_Query_HalogenM.monadStateHalogenM)(function (v2) {
                                        var $11 = {};
                                        for (var $12 in v2) {
                                            if ({}.hasOwnProperty.call(v2, $12)) {
                                                $11[$12] = v2[$12];
                                            };
                                        };
                                        $11.currentUser = mbProfile;
                                        return $11;
                                    });
                                });
                            });
                        });
                    };
                    if (v instanceof HandleUserBus) {
                        return Control_Monad_State_Class.modify_(Halogen_Query_HalogenM.monadStateHalogenM)(function (v1) {
                            var $16 = {};
                            for (var $17 in v1) {
                                if ({}.hasOwnProperty.call(v1, $17)) {
                                    $16[$17] = v1[$17];
                                };
                            };
                            $16.currentUser = v.value0;
                            return $16;
                        });
                    };
                    if (v instanceof Receive) {
                        return Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)(Control_Monad_State_Class.get(Halogen_Query_HalogenM.monadStateHalogenM))(function (v1) {
                            return Control_Monad_State_Class.put(Halogen_Query_HalogenM.monadStateHalogenM)(Record.insert(new Data_Symbol.IsSymbol(function () {
                                return "currentUser";
                            }))()()(Data_Symbol.SProxy.value)(v1.currentUser)(v.value0));
                        });
                    };
                    if (v instanceof Emit) {
                        return Halogen_Query_HalogenM.raise(v.value0);
                    };
                    throw new Error("Failed pattern match at Lunarbox.Component.HOC.Connect (line 61, column 18 - line 71, column 34): " + [ v.constructor.name ]);
                };
                return Halogen_Component.mkComponent({
                    initialState: Record.insert(new Data_Symbol.IsSymbol(function () {
                        return "currentUser";
                    }))()()(Data_Symbol.SProxy.value)(Data_Maybe.Nothing.value),
                    render: render,
                    "eval": Halogen_Component.mkEval({
                        handleAction: handleAction,
                        handleQuery: handleQuery,
                        receive: function ($25) {
                            return Data_Maybe.Just.create(Receive.create($25));
                        },
                        initialize: new Data_Maybe.Just(Initialize.value),
                        finalize: Halogen_Component.defaultEval.finalize
                    })
                });
            };
        };
    };
};
module.exports = {
    Initialize: Initialize,
    HandleUserBus: HandleUserBus,
    Receive: Receive,
    Emit: Emit,
    "_inner": _inner,
    component: component
};
